import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { authStorage } from "../../services/authStorage";

export const FHOST = (
  process.env.REACT_APP_API_URL ||
  "https://studybuddy-backend-6vya.onrender.com"
).replace(/\/api\/?$/, "");

export const checkUser = async (email) => {
  //  FIX: Pointing to the exact explicit route defined in config/urls.py
  const serverUrl = `${FHOST}/api/auth/check_user/`;

  try {
    const response = await axios.post(serverUrl, { email });

    const responseData = response.data;

    if (responseData !== null) {
      return responseData;
    }
    return { error: "User not found" };
  } catch (error) {
    console.error("Error checking email:", error);

    if (error.response && error.response.data && error.response.data.message) {
      return { error: error.response.data.message };
    }

    return { error: "An unknown error occurred" };
  }
};

export const decodeJwtToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log(decoded);
    return decoded;
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

export const refreshAccessToken = async () => {
  const refreshToken = authStorage.getRefreshToken();
  if (!refreshToken) throw new Error("No refresh token, Please login again");

  const response = await axios.post(`${FHOST}/api/token/refresh/`, {
    refresh: refreshToken,
  });

  console.log("response", response);

  const newAccessToken = response.data.access;
  authStorage.setTokens(newAccessToken, refreshToken);
  return newAccessToken;
};
